import {
  type QuestionnaireAnswerApiOutContract,
  type VisitPatientPreferenceStaffApiOutContract,
} from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'

/**
 * PRJ-578 — UI-only mocks for the live (video) visit display.
 *
 * They exist to make the live-visit rendering reviewable: a requested pharmacy for a live visit
 * whose `PatientPreference` the backend leaves unpopulated, and answers to the pre-booking
 * medication questions, which the PRD has since removed from the flow.
 *
 * Shown only while the `live_visit_hd_mock` Dev Tools pin is on (`selectLiveVisitHdMockEnabled`),
 * which defaults off and cannot be pinned where production is served. With it off, video visits
 * keep their real intake form and their real, possibly blank, requested pharmacy.
 *
 * TODO(PRJ-578): delete this module, the `live_visit_hd_mock` flag and its selector once the
 * backend surfaces the real live-visit `PatientPreference` (read it off the visit query instead,
 * see `useVisitPopUpState` / `useGetVisitsVisitIdV2`), or sooner if the medication-questions panel
 * is dropped.
 */

// A null `Pharmacy` means home delivery (see VisitPatientPreferenceStaffApiOutContract docs).
export const MOCK_LIVE_VISIT_PATIENT_PREFERENCE: VisitPatientPreferenceStaffApiOutContract = {
  CurrentMedication: {
    DrugName: 'Branded Suboxone',
    Dosage: '8-2MG',
    Frequency: 'Twice daily',
  },
  Pharmacy: null,
}

export const MOCK_LIVE_VISIT_MEDICATION_ANSWERS: QuestionnaireAnswerApiOutContract[] = [
  {
    Question: 'Is your current medication working well for you?',
    Answer: 'Yes, it has been managing my symptoms well.',
  },
  {
    Question: 'Have you noticed any new side effects since your last visit?',
    Answer: 'No new side effects.',
  },
  {
    Question: 'Are you experiencing any cravings or withdrawal symptoms?',
    Answer: 'Occasional mild cravings, no withdrawal symptoms.',
  },
]
